module.exports = __webpack_public_path__ + "static/media/S44.06f7afed.png";